export const LARGE_MAP_NODE_THRESHOLD = 50;
export const LARGE_MAP_EDGE_THRESHOLD = 100;

export function shouldRenderOnlyVisibleMapElements(
  nodeCount,
  edgeCount,
  { exporting = false } = {}
) {
  if (exporting) return false;
  return Number(nodeCount) >= LARGE_MAP_NODE_THRESHOLD
    || Number(edgeCount) >= LARGE_MAP_EDGE_THRESHOLD;
}

